import { Navigate, useParams } from 'react-router-dom';

import { RootState } from '../redux/store';
import { isLoggedIn } from '../utils/utils';
import { NAVIGATE_ADMIN } from '../constant';
import { useSelector } from '../hooks/useSelector';

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
    const authUser = useSelector((state: RootState) => state.authUser);
    const { menus } = useSelector((state: RootState) => state.permission);
    const isRolesPermissionsSet = localStorage.getItem('roles_permissions') !== null;
    const { companyCode } = useParams<{ companyCode: string }>();

    if (isLoggedIn(authUser) && menus?.length > 0 && isRolesPermissionsSet) {
        if (authUser.User) {            
            return <Navigate to={`/${companyCode}${NAVIGATE_ADMIN.DASHBOARD_PAGE}`} replace/>;
        }
    } 

    return (
        <>{children}</>
    )
}

export default AuthLayout;